<div>
    <app-audi-text variant="order4" className="audi-type-normal" text="The page you're looking for couldn't be found.">
    </app-audi-text>
</div>